import {
  ComponentMultiStyleConfig,
  Flex,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type StepItemProps = {
  label: string;
  description: string;

  active: boolean;
} & ComponentStyleProps;

export const StepItem = ({
  label,
  description,

  active,

  sx,
  ...rest
}: StepItemProps) => {
  const styles = useMultiStyleConfig("StepItemStyles");

  return (
    <Flex
      direction="column"
      wrap="nowrap"
      sx={{
        ...styles.containerBase,
        ...(active ? styles.containerActive : null),
        ...sx,
      }}
      {...rest}
    >
      <Text
        sx={{
          ...styles.labelBase,
          ...(active ? styles.labelActive : null),
        }}
      >
        {label}
      </Text>
      <Text
        sx={{
          ...styles.descriptionBase,
          ...(active ? styles.descriptionActive : null),
        }}
      >
        {description}
      </Text>
    </Flex>
  );
};

export const StepItemStyles: ComponentMultiStyleConfig = {
  parts: [
    "containerBase",
    "containerActive",
    "labelBase",
    "labelActive",
    "descriptionBase",
    "descriptionActive",
  ],
  baseStyle: {
    containerBase: {
      borderTopWidth: "4px",
      borderColor: "gray.200",
    },
    containerActive: {
      borderColor: "teal.500",
    },
    labelBase: {
      mt: "4",
      fontWeight: "semibold",
      fontSize: "xs",
      color: "gray.500",
    },
    labelActive: {
      color: "teal.500",
    },
    descriptionBase: {
      fontSize: "md",
      color: "gray.900",
    },
    descriptionActive: {
      fontSize: "md",
      color: "gray.900",
    },
  },
};
